/**
 * Helpers for the vocab/subset test config in the test editor.
 *
 * A retakeable subset test deals questions WITHOUT replacement — no word repeats
 * until the whole pool is exhausted, then a fresh cycle starts. For that to "fall
 * off nicely" (every cycle empties the pool with no leftover tail), the
 * questions-per-attempt value must divide the pool size evenly. We therefore only
 * offer the pool's divisors as choices.
 */

/** All positive divisors of n (ascending). Returns [] for non-positive / non-integer n. */
export const divisorsOf = (n) => {
    const count = Number(n);
    if (!Number.isInteger(count) || count < 1) return [];
    const out = [];
    for (let d = 1; d <= count; d += 1) {
        if (count % d === 0) out.push(d);
    }
    return out;
};

/**
 * Valid "questions per attempt" subset sizes for a pool of `poolSize`:
 * the proper divisors (1 .. poolSize-1). The full pool is excluded because
 * "serve every question" is the separate "whole test" option (value '').
 */
export const perAttemptOptions = (poolSize) =>
    divisorsOf(poolSize).filter((d) => d < Number(poolSize));
